export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4792.91b4785d.jpg";